<div class="phone-field" [class.phone-field--focused]="focused">
  <input #phoneInput type="tel" [attr.required]="required || null" />
</div>
